import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/tra/webshop/frontend/src/bag/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/builds/tra/webshop/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/layouts/empty.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/builds/tra/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/layouts/checkout.vue").then(m => m.default || m))
}